import { of } from "rxjs";
import { actionBuildingPurchaseConfirmationRequest } from "../actionBuildings";
export var pathPurchaseBuildingInitiate = function (action, state$) { return of(actionBuildingPurchaseConfirmationRequest(action.building, action.premium)); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathPurchaseBuildingInitiate.ts
// module id = 2069
// module chunks = 3